<template>
  <div class="success">
    <div class="content">
      <div class="title">考试信息</div>
      <div class="detail">
        <img src="../../assets/exam/success.png" alt="" />
        <div class="suc">交卷成功</div>
        <div class="do">您已经交卷，请快速安静离开考场</div>
        <div class="time">
          <span class="date">{{ time }}</span> 后自动返回到考试中心
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timer;
export default {
  data() {
    return {
      time: "",
    };
  },
  created() {
    clearInterval(timer);
    this.time = 5;
    timer = setInterval(() => {
      this.time--;
      if (this.time == 0) {
        clearInterval(timer);
        this.$router.push({ path: "/exam/examCenter" });
      }
    }, 1000);
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.success {
  background-color: #f5f7fa;
  padding: 40px 0;
  box-sizing: border-box;
  height: 100vh;
  .content {
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    min-height: 668px;
    background-color: #fff;
    padding-bottom: 120px;
    .title {
      line-height: 60px;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      padding-left: 30px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8ebf2;
    }
    .detail {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 120px;
      img {
        width: 200px;
        height: 200px;
      }
      .suc {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #16a266;
        margin: 16px 0 30px;
      }
      .do {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #666666;
      }
      .time {
        margin-top: 20px;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #808080;
        .date {
          color: #ff5554;
        }
      }
    }
  }
}
</style>
